import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useUpdateEffect } from '@react-hookz/web';
import { useConfiguration, useBreakpointDown } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import emailSentSuccess from '../../../assets/images/authentication/activateAccount.svg';
import { WidgetLayout } from '../../../components/Authentication/components/index.js';
import { SuccessMigrateAccountDialog } from '../../../components/Authentication/dialogs/index.js';
import { validationsConfig } from '../../../components/Authentication/helpers.js';
import { migrateAccount } from '../../../components/Authentication/redux/actions.js';
import { authState } from '../../../components/Authentication/redux/AuthState.js';
import { NextImage } from '../../../components/internal/NextImage/index.js';
import { useAuthentication, useValidation, useValidationError, useValidationErrorEvaluate } from '../../../hooks/index.js';
import { Button, HeadlineLarge, ParagraphMedium, Stack, TextField } from '../../../primitives/index.js';
export const MigrateAccount = ({
  ...restProps
}) => {
  const {
    t
  } = useTranslation('authentication');
  const smDown = useBreakpointDown('sm');
  const dispatch = useDispatch();
  const {
    isComponentOpen
  } = useAuthentication();
  const {
    validate
  } = useValidation(validationsConfig);
  const {
    errors,
    setFieldErrors,
    resetErrors
  } = useValidationError([]);
  const {
    isFieldValid
  } = useValidationErrorEvaluate(errors);
  const {
    isLoading
  } = useSelector(authState);
  const size = smDown ? 'small' : 'medium';
  const [email, setEmail] = useState('');
  const handleSubmit = event => {
    event.preventDefault();
    let isFormValid = true;
    const errors = validate([{
      field: 'emailAddress',
      value: email
    }]);
    if (errors.length > 0) {
      isFormValid = false;
      setFieldErrors(errors, 'emailAddress');
    }
    if (isFormValid) {
      handleButtonClick();
    }
  };
  useUpdateEffect(() => {
    resetErrors();
  }, [isComponentOpen('widget', 'migrateAccount')]);
  const authUrl = useConfiguration('authUrl');
  const handleButtonClick = useCallback(() => {
    // @ts-expect-error TS(2345) FIXME
    dispatch(migrateAccount(authUrl, email));
  }, [dispatch, email, authUrl]);
  const handleFocus = useCallback(field => () => {
    setFieldErrors([], field);
  }, [setFieldErrors]);
  const isSubmitDisabled = errors.length > 0 || isLoading || !email;
  return _jsxs(_Fragment, {
    children: [_jsx(WidgetLayout, {
      widget: "migrateAccount",
      title: t('migrateAccount.ariaTitle'),
      ...restProps,
      children: _jsx("form", {
        onSubmit: handleSubmit,
        noValidate: true,
        children: _jsxs(Stack, {
          spacing: "large",
          alignItems: "center",
          children: [_jsx(NextImage, {
            image: emailSentSuccess,
            alt: "",
            width: 200,
            height: 200
          }), _jsxs(Stack, {
            spacing: "medium",
            alignItems: "center",
            children: [_jsx(HeadlineLarge, {
              textAlign: "center",
              children: t('migrateAccount.title')
            }), _jsx(ParagraphMedium, {
              textAlign: "center",
              color: "contentSecondary",
              children: t('migrateAccount.subtitle')
            })]
          }), _jsx(TextField, {
            size: size,
            fullWidth: true,
            id: "email",
            type: "email",
            autoComplete: "username",
            label: t('migrateAccount.email.placeholder'),
            onChange: e => setEmail(e.target.value),
            invalid: !isFieldValid('emailAddress'),
            onFocus: handleFocus('emailAddress'),
            onBlur: () => setEmail(previous => previous),
            message: !isFieldValid('emailAddress') && t('migrateAccount.email.invalid')
          }), _jsx(Button, {
            fullWidth: true,
            disabled: isSubmitDisabled,
            type: "submit",
            children: t('migrateAccount.buttonText')
          })]
        })
      })
    }), _jsx(SuccessMigrateAccountDialog, {})]
  });
};